import { render, staticRenderFns } from "./GraficoCategoriaDeArvore.vue?vue&type=template&id=396d582a&scoped=true"
import script from "./GraficoCategoriaDeArvore.vue?vue&type=script&lang=js"
export * from "./GraficoCategoriaDeArvore.vue?vue&type=script&lang=js"
import style0 from "./GraficoCategoriaDeArvore.vue?vue&type=style&index=0&id=396d582a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d582a",
  null
  
)

export default component.exports